export default {
  appTitle: 'Arcaea - 创新立体节奏游戏',
  appDescription: '和蔼的纯白色光芒，正在那失落世界的旋律斗争中等待着你。三维立体节奏游戏。',
  hrefLang: 'zh_Hans',
  confirm: '确认',
  cancel: '取消',
  hours: '{hours}小时',
  minutes: '{minutes}分钟',
  seconds: '{seconds}秒',
  error: '错误',
  generalError: '发生错误，请刷新重试',
  potential: '潜力值',
  daysLeft: '剩余{day}天',
  subscribe: '订阅',
  subscribeCancel: '取消订阅',
  loading: '加载中',
  search: 'Search...',
  redirecting: '正在为您跳转……',
  return: '返回',
  returnToArcaeaOnline: '返回Arcaea Online',
  ok: '好的',
  save: '保存',
  calculating: '统计中……',
  clearStatsDisclaimer: '请注意，Arcaea Online提供的游玩记录均为玩家在线游玩的数据，因此可能与离线游玩的数据有所差异。',
  changelog: {
    title: `Arcaea Online更新一览`,
    list: `
    <div>免费功能：</div>
    <ul class="changelog-list">
      <li>在档案界面显示曲目通关情况</li>
      <li>可在档案和个人最佳成绩界面自定义场景</li>
      <li>欧洲部分国家和地区现可使用PayPal支付（其他地区敬请期待）</li>
    </ul>
    <div>订阅功能：</div>
    <ul class="changelog-list">
      <li>分数界面新增曲目搜索功能</li>
      <li>分数界面新增"距离理论值"排序方式，玩家可查看各曲目最高分与各曲目理论值的差距</li>
      <li>潜力值界面新增Pure/Far/Lost数据</li>
      <li>可在分数与潜力值界面查看获得分数的日期</li>
      <li>可查看"3年"及"5年"内的潜力值变动范围</li>
    </ul>`
  },
  menu: {
    songRanking: '歌曲排行',
    story: '故事',
    goods: '周边',
    login: '登录',
    account: '我的账号'
  },
  footer: {
    copyright: '© 2023 lowiro',
    contact: '联系我们',
    terms: '服务条款',
    derivativeWorks: '二次创作管理条例',
    privacyPolicy: '隐私权政策',
    streamingGuidelines: '直播准则'
  },
  homepage: {
    artist: '作者',
    artwork: '封面设计',
    songDescription: '在游戏中可游玩的部分精选曲目',
    availableOnAndroid: '可通过安卓系统下载'
  },
  account: {
    login: '登录',
    logout: '注销',
    errorLogin: '登入失败。请检查您的用户名与密码。',
    username: '用户名',
    checking: '正在检测...',
    changeUsername: '更改用户名',
    nameUnavailable: '名称已被占用。请使用另一个名称。',
    nameInvalid: '账户名包含3到15个字符：英文字母或阿拉伯数字',
    email: '电子邮箱',
    changeEmail: '更换电子邮箱',
    errorEmailUnavailable: '此电子邮箱已被注册过<br/>请使用其他电子邮箱',
    memories: '记忆源点',
    buyMore: '购买',
    passwordReset: '重置密码',
    enterEmail: '请输入您的电子邮箱地址',
    submit: '提交',
    usernameEmailID: '用户名、电子邮箱或用户ID',
    forgotPassword: '忘记密码？',
    errorInvalidEmail: '请输入有效的电子邮箱地址',
    errorUnknownEmail: '未知的邮箱地址',
    requestForgotSuccess: '一个链接已发送至你的邮箱。请点击链接来重置密码。',
    newPassword: '请输入新密码',
    newPasswordConfirm: '确认新密码',
    passwordResetInput: '新密码',
    passwordResetConfirm: '确认密码',
    passwordResetSuccess: '密码变更成功',
    errorMismatchPassword: '密码不相符',
    errorInvalidPassword: '密码至少为八位数字',
    errorInvalidResetToken: '此链接已失效。请试图获取新的链接。',
    password: '密码',
    loginCaps: '登入',
    creditCard: '信用卡/其他',
    purchaseMemories: '购买记忆源点',
    wouldLikePurchase: '购买<span class="bold">{amount}记忆源点</span>?',
    nameChangeWarn: '需要支付<span class="bold highlight-color">{amount} 记忆源点</b>。<br/>确定继续吗？',
    payUsing: '付款方式',
    proccessingPayment: '正在处理',
    purchase: '购买',
    purchaseFailed: '购买失败',
    purchaseFailedDescription: '您的购买没有完成。<br/>请再试一次。',
    purchaseComplete: '购买完成',
    justAdded: '您已完成购买{amount}记忆源点。',
    thankYou: '感谢您的购买！',
    Account: '账号',
    backToAccount: '返回账号',
    currentMemories: '现有记忆源点',
    usernameCost: '更改您的用户名将需要您支付<span class="bold">{amount} 记忆源点</span>。',
    change: '更改',
    cancel: '取消',
    newName: '新用户名',
    newNameConfirm: '您的用户名将更改为：',
    newEmailConfirm: '您的电子邮箱将更改为：',
    newEmail: '新的电子邮箱',
    emailChangeWarn: '你确定要将电子邮箱更换为<b>{email}</b>吗?',
    checkInbox: '请您于收件箱中查看验证链接',
    verifyingEmail: '正在验证...',
    verifyEmailSuccess: '电子邮箱修改成功',
    errorVerifyEmail: '电子邮箱修改失败，请重新尝试',
    confirmPaymentChina: `使用此付款服务时，我确认自己正身处中华人民共和国境内。<br/>我同时明白，在中华人民共和国境外使用此付款服务可能会导致我的账号被封锁。`,
    agree: '同意',
    version: '版本{version}',
    deleteUser: '删除账号的请求确认',
    verifyDeleteUserSuccess: '你的Arcaea账号已被成功删除',
    errorVerifyDeleteUser: '账号未能被成功删除，请重试',
    verifyingDeleteUser: '正在验证...',
    selectYourRegion: '选择地区',
    ensureSelectRegion: '在购买记忆源点之前，请确保您所选择的付款方式的来源地区和您选择的地区一致。',
    selectRegionConfirm: '已选择的地区',
    digitalContents: '电子版资源',
    manageDigitalOST: '管理/下载',
    owned: '已拥有{amount}',
    errorInvalidUserCode: 'ID 应为九位数字',
    errorAddFriend: '发生了问题，添加好友失败',
  },
  arcaeaOnline: {
    subscribedUntil: '	您的订阅将于{date}失效',
    benefit1: '查看曲目得分情况',
    benefit2: '查看好友总分排名',
    benefit3: '查看潜力值相关数据',
  },
  scoreData: {
    playsThisYear: '游玩次数（次/年）',
    leaderboards: '排行榜',
    obtained: `取得日期`,
    obtainedDate: `取得日期：{date}`,
  },
  leaderboard: {
    totalScoreRanking: 'Total Score Ranking',
    world: '世界',
    friend: '好友',
    top50: '前50',
    myRank: '我的排名',
    lastUpdated: '更新于: {date}',
  },
  ptt: {
    topRatedRecentPlays: '近期最佳表现',
    top30Plays: 'Best 30',
    noPlays: '无记录',
    '1W': '近1周',
    '1M': '近1月',
    '1Y': '近1年',
  },
  friend: {
    addFriend: '添加好友',
    pleaseEnterPlayerId: '请输入好友ID',
    sendFriendRequest: '添加好友',
    friendCount: '{friendCount}/{maxCount}个好友',
    removeFriendTitle: '删除好友',
    removeFriend: '确认删除',
    areYouSureRemove: '确认刪除好友<b>{name}</b>？',
    friendList: '好友列表',
    maxIncreaseInGame: '可以在Arcaea应用程序中提高好友数量上限',
    errorFriendYourself: '你不能加自己为好友 ;_;',
    errorAlreadyFriend: '此用户已是好友',
    errorDoesNotExist: '用户不存在',
    errorFriendLimit: '你的好友列表已满',
  },
  subscription: {
    subscription: '订阅',
    subscribe: '订阅',
    autoRenew: '自动续费',
    renewalInfo: '若账户拥有足够记忆源点，开通自动续费后，每隔30天将会自动扣费续订。',
    benefitHeader: '订阅权益',
    spendMemories: '是否花费<b>200</b>记忆源点激活30天订阅？',
    confirmPurchase: '确认',
    notEnoughMemories: '记忆源点不足',
    memoriesRequired: '需要{amount}记忆源点',
    redirectToMemory: '是否要跳转到记忆源点购买页进行增值？',
    confirmCancel: '确定要取消订阅吗？',
    cancelDisclaimer: '取消订阅后仍可在订阅有效期内继续享受订阅权益，订阅周期结束时权益将自动失效。',
    keepSubscription: '我想要继续订阅',
    cancelSubscription: '取消订阅',
    paymentComplete: '订阅成功',
    paymentCompleteMessage: '订阅成功！感谢您对Arcaea Online的支持！',
    required: '需要订阅以使用此功能',
    requiredText: '订阅Arcaea Online后，该页面将解锁。',
    goToSubscribe: '订阅',
    yourSubscription: '您的订阅',
    renewMessage: '订阅将于{arcaeaOnlineExpiredDate}续订。',
    reactivate: '重新订阅',
    success: '订阅成功',
    successMessage: '订阅成功！感谢您对Arcaea Online的支持！',
    cancelled: '订阅已取消',
    cancelledMessage: '您已取消订阅Arcaea Online，先前的订阅权益将保留至{arcaeaOnlineExpiredDate}'
  },
  clearType: {
    clear: 'CLEAR',
    fr: 'FULL RECALL',
    pm: 'PURE MEMORY',
  },
  sort: {
    by: '排序方式',
    name: '名称',
    level: '等级',
    date: '日期',
    score: '分数',
    title: '曲名',
    scoreBelowMax: '距离理论值'
  },
  partner: {
    level: '等级',
    currentPartner: '当前搭档',
    selected: '已选中'
  },
  characterType: {
    0: 'BALANCE',
    1: 'SUPPORT',
    2: 'CHALLENGE',
    3: 'CREATOR',
  },
  profile: {
    scenerySelectTitle: '选择场景',
    sceneryUnlockInGame: '场景可通过世界模式解锁'
  },
  worldUnlock: {
    locked: '经由世界模式解除封印<br/>{index}',
    beginning: '起始之章',
    lockedchap1: '章节 1',
    lockedchap2: '章节 2',
    lockedchap3: '章节 3',
    lockedchap4: '章节 4',
    lockedchap5: '章节 5',
    lockedchap6: '章节 6',
    lockedchap7: '章节 7',
    lockedbeyond: 'Lost Chapter: Beyond',
    unlockedchap1 : '失落的世界',
    unlockedchap2 : '谜域的界外',
    unlockedchap3 : '聚合的塔尖',
    unlockedchap4 : '沉眠的回声',
    unlockedchap5 : '无央的决裂',
    unlockedchap6 : '遗忘的构念',
    unlockedchap7 : '回首的天际',
    unlockedbeyond: 'Lost Chapter: Beyond',
  },
  sidebar: {
    profile: '档案',
    friends: '好友',
    partners: '搭档',
    leaderboards: '排行榜',
    scoreData: '分数',
    potential: '潜力值',
    memoriesAndSubscription: '记忆源点与订阅',
    accountAndSettings: '帐号及设定',
  },
  goods: {
    originalSoundtracks: '原声音乐',
    diverseDirect: 'DIVERSE DIRECT',
    tanoc: 'TANO*C STORE',
    amazon: 'Amazon.co.jp',
    lineHeader: 'Arcaea官方LINE贴图',
    lineText1: '使用你最喜欢的Arcaea角色，让聊天更可爱更多彩！',
    lineButton: '前往 LINE STORE'
  },
  digitalContents: {
    ostHeader: '官方原声专辑',
    generateDownloadLink: '生成下载链接',
    redeemOST: '兑换电子版专辑',
    redeemOSTDescription: '请取出专辑盒中的兑换码，打开“<b>韵律源点Arcaea</b>”APP并点击“<b>网络</b>”图标，后点击“<b>兑换码</b>”兑换。',
    downloadRemaining: '下载中，剩余{amount}',
    downloadsRemaining: '下载中，剩余{amount}',
    notOwned: '未获得'
  },
  songRanking: {
    freeMusic: '免费曲目',
    paidMusic: '收费曲目',
    title: '标题',
    artist: '作者',
    new: '新'
  },
  verify: {
    verifyAccount: '帐号验证',
    enterEmail: '请输入注册邮箱',
    verify: '验证',
    verifySuccess: '账号已成功验证。',
    verifyError: '认证账号时发生了未知错误，',
    clickHere: '点击此处',
    verifySupport: '请{0}联系技术支持。',
    errorInvalidEmail: '请输入有效的邮箱地址',
    errorInvalidToken: '无法完成注册。原因：链接无效或注册已超时。请查看收件箱或重新注册。',
    errorExpiredToken: '未在指定时间内完成帐号注册，请重新注册帐号。',
    errorCaptchaFailed: 'CAPTCHA验证失败，请重试。',
  },
  purchase: {
    sorryNotSupported: '非常抱歉，Arcaea官网暂不支持从您所在的地区购买。',
    memoryWithBonus: '{amount} + {bonusAmount}（附赠）',
    priceCurrencyFront: '{currency}{amount}',
    priceCurrencyBack: '{amount}{currency}'
  },
  story: {
    slide1: {
      text: `两个少女前往探索一个支离破碎的世界。那里伴随着一个声音：一段尘封的过往即将被揭开...<br/>
<br/>
她们从这个除了废墟一无所有的世界中醒来，却丝毫不记得这里曾发生过的一切。这一刻她们才发现，自己也不过是虚无的存在。<br/>
而接下来，她们会发现一个名叫Arcaea的物体。它由空中漂浮着玻璃质感般的碎片所积聚而成，而这每一块碎片，都包含着来自过去的鲜活回忆。<br/>`,
    },
    slide2: {
      text: `这些碎片向两个少女身边靠拢，似乎就像是它们在选择让谁来体验这段尘封的记忆。<br/>
而少女们也通过自己的方式，体验到了完全不同的过去。<br/>
<br/>
<i>这些玻璃反射出了另一个纯洁的世界。她从中看见海洋、城市、火焰、光芒；美好的景象目不暇接。她抬起了自己的手，试图去抓住它们，开心地笑了出来。</i><br/>
<br/>
<i>就像透过火车车窗看外头稍纵即逝的景色一般，她瞧见了阴雨的景象。下一次是艳阳。再下一次是死亡。她厌恶地远离了这些碎片。</i><br/>
      `
    },
    slide3: {
      text: `两个少女在探索着支离破碎的世界中逐渐解锁那尘封的过去。<br/>
<br/>
一侧是光，另一侧是对立。<br/>
<br/>
她们在Arcaea世界中所探索的一切会改变她们吗？<br/>
<br/>
<i>这美好而又简简单单的世界，只需要令人感到愉快就足够了。没错，无需多求。</i><br/>
<br/>
<i>但无论这些碎片在反射什么……她从中未见到一丝光芒。哪怕是最小的火花，都会在一瞬间消失于她的视线。</i><br/>
<br/>
而这之后，在旅途的尽头，她们又会变成谁？
`,
    }
  },
  links: {},
  countries: [
    { "id": 4, "name": "阿富汗", "a2": "af" },
    { "id": 248, "name": "奥兰", "a2": "ax" },
    { "id": 8, "name": "阿尔巴尼亚", "a2": "al" },
    { "id": 12, "name": "阿尔及利亚", "a2": "dz" },
    { "id": 16, "name": "美属萨摩亚", "a2": "as" },
    { "id": 20, "name": "安道尔", "a2": "ad" },
    { "id": 24, "name": "安哥拉", "a2": "ao" },
    { "id": 660, "name": "安圭拉", "a2": "ai" },
    { "id": 10, "name": "南极洲", "a2": "aq" },
    { "id": 28, "name": "安提瓜和巴布达", "a2": "ag" },
    { "id": 32, "name": "阿根廷", "a2": "ar" },
    { "id": 51, "name": "亚美尼亚", "a2": "am" },
    { "id": 533, "name": "阿鲁巴", "a2": "aw" },
    { "id": 36, "name": "澳大利亚", "a2": "au" },
    { "id": 40, "name": "奥地利", "a2": "at" },
    { "id": 31, "name": "阿塞拜疆", "a2": "az" },
    { "id": 44, "name": "巴哈马", "a2": "bs" },
    { "id": 48, "name": "巴林", "a2": "bh" },
    { "id": 50, "name": "孟加拉国", "a2": "bd" },
    { "id": 52, "name": "巴巴多斯", "a2": "bb" },
    { "id": 112, "name": "白俄罗斯", "a2": "by" },
    { "id": 56, "name": "比利时", "a2": "be" },
    { "id": 84, "name": "伯利兹", "a2": "bz" },
    { "id": 204, "name": "贝宁", "a2": "bj" },
    { "id": 60, "name": "百慕大", "a2": "bm" },
    { "id": 64, "name": "不丹", "a2": "bt" },
    { "id": 68, "name": "玻利维亚", "a2": "bo" },
    { "id": 535, "name": "荷兰加勒比区", "a2": "bq" },
    { "id": 70, "name": "波黑", "a2": "ba" },
    { "id": 72, "name": "博茨瓦纳", "a2": "bw" },
    { "id": 74, "name": "布韦岛", "a2": "bv" },
    { "id": 76, "name": "巴西", "a2": "br" },
    { "id": 86, "name": "英属印度洋领地", "a2": "io" },
    { "id": 96, "name": "文莱", "a2": "bn" },
    { "id": 100, "name": "保加利亚", "a2": "bg" },
    { "id": 854, "name": "布基纳法索", "a2": "bf" },
    { "id": 108, "name": "布隆迪", "a2": "bi" },
    { "id": 132, "name": "佛得角", "a2": "cv" },
    { "id": 116, "name": "柬埔寨", "a2": "kh" },
    { "id": 120, "name": "喀麦隆", "a2": "cm" },
    { "id": 124, "name": "加拿大", "a2": "ca" },
    { "id": 136, "name": "开曼群岛", "a2": "ky" },
    { "id": 140, "name": "中非", "a2": "cf" },
    { "id": 148, "name": "乍得", "a2": "td" },
    { "id": 152, "name": "智利", "a2": "cl" },
    { "id": 156, "name": "中国大陆", "a2": "cn" },
    { "id": 162, "name": "圣诞岛", "a2": "cx" },
    { "id": 166, "name": "科科斯（基林）群岛", "a2": "cc" },
    { "id": 170, "name": "哥伦比亚", "a2": "co" },
    { "id": 174, "name": "科摩罗", "a2": "km" },
    { "id": 178, "name": "刚果共和国", "a2": "cg" },
    { "id": 180, "name": "刚果民主共和国", "a2": "cd" },
    { "id": 184, "name": "库克群岛", "a2": "ck" },
    { "id": 188, "name": "哥斯达黎加", "a2": "cr" },
    { "id": 384, "name": "科特迪瓦", "a2": "ci" },
    { "id": 191, "name": "克罗地亚", "a2": "hr" },
    { "id": 192, "name": "古巴", "a2": "cu" },
    { "id": 531, "name": "库拉索", "a2": "cw" },
    { "id": 196, "name": "塞浦路斯", "a2": "cy" },
    { "id": 203, "name": "捷克", "a2": "cz" },
    { "id": 208, "name": "丹麦", "a2": "dk" },
    { "id": 262, "name": "吉布提", "a2": "dj" },
    { "id": 212, "name": "多米尼克", "a2": "dm" },
    { "id": 214, "name": "多米尼加", "a2": "do" },
    { "id": 218, "name": "厄瓜多尔", "a2": "ec" },
    { "id": 818, "name": "埃及", "a2": "eg" },
    { "id": 222, "name": "萨尔瓦多", "a2": "sv" },
    { "id": 226, "name": "赤道几内亚", "a2": "gq" },
    { "id": 232, "name": "厄立特里亚", "a2": "er" },
    { "id": 233, "name": "爱沙尼亚", "a2": "ee" },
    { "id": 748, "name": "斯威士兰", "a2": "sz" },
    { "id": 231, "name": "埃塞俄比亚", "a2": "et" },
    { "id": 238, "name": "福克兰群岛", "a2": "fk" },
    { "id": 234, "name": "法罗群岛", "a2": "fo" },
    { "id": 242, "name": "斐济", "a2": "fj" },
    { "id": 246, "name": "芬兰", "a2": "fi" },
    { "id": 250, "name": "法国", "a2": "fr" },
    { "id": 254, "name": "法属圭亚那", "a2": "gf" },
    { "id": 258, "name": "法属波利尼西亚", "a2": "pf" },
    { "id": 260, "name": "法属南部和南极领地", "a2": "tf" },
    { "id": 266, "name": "加蓬", "a2": "ga" },
    { "id": 270, "name": "冈比亚", "a2": "gm" },
    { "id": 268, "name": "格鲁吉亚", "a2": "ge" },
    { "id": 276, "name": "德国", "a2": "de" },
    { "id": 288, "name": "加纳", "a2": "gh" },
    { "id": 292, "name": "直布罗陀", "a2": "gi" },
    { "id": 300, "name": "希腊", "a2": "gr" },
    { "id": 304, "name": "格陵兰", "a2": "gl" },
    { "id": 308, "name": "格林纳达", "a2": "gd" },
    { "id": 312, "name": "瓜德罗普", "a2": "gp" },
    { "id": 316, "name": "关岛", "a2": "gu" },
    { "id": 320, "name": "危地马拉", "a2": "gt" },
    { "id": 831, "name": "根西", "a2": "gg" },
    { "id": 324, "name": "几内亚", "a2": "gn" },
    { "id": 624, "name": "几内亚比绍", "a2": "gw" },
    { "id": 328, "name": "圭亚那", "a2": "gy" },
    { "id": 332, "name": "海地", "a2": "ht" },
    { "id": 334, "name": "赫德岛和麦克唐纳群岛", "a2": "hm" },
    { "id": 336, "name": "梵蒂冈", "a2": "va" },
    { "id": 340, "name": "洪都拉斯", "a2": "hn" },
    { "id": 344, "name": "香港", "a2": "hk" },
    { "id": 348, "name": "匈牙利", "a2": "hu" },
    { "id": 352, "name": "冰岛", "a2": "is" },
    { "id": 356, "name": "印度", "a2": "in" },
    { "id": 360, "name": "印尼", "a2": "id" },
    { "id": 364, "name": "伊朗", "a2": "ir" },
    { "id": 368, "name": "伊拉克", "a2": "iq" },
    { "id": 372, "name": "爱尔兰", "a2": "ie" },
    { "id": 833, "name": "马恩岛", "a2": "im" },
    { "id": 376, "name": "以色列", "a2": "il" },
    { "id": 380, "name": "意大利", "a2": "it" },
    { "id": 388, "name": "牙买加", "a2": "jm" },
    { "id": 392, "name": "日本", "a2": "jp" },
    { "id": 832, "name": "泽西", "a2": "je" },
    { "id": 400, "name": "约旦", "a2": "jo" },
    { "id": 398, "name": "哈萨克斯坦", "a2": "kz" },
    { "id": 404, "name": "肯尼亚", "a2": "ke" },
    { "id": 296, "name": "基里巴斯", "a2": "ki" },
    { "id": 408, "name": "朝鲜", "a2": "kp" },
    { "id": 410, "name": "韩国", "a2": "kr" },
    { "id": 414, "name": "科威特", "a2": "kw" },
    { "id": 417, "name": "吉尔吉斯斯坦", "a2": "kg" },
    { "id": 418, "name": "老挝", "a2": "la" },
    { "id": 428, "name": "拉脱维亚", "a2": "lv" },
    { "id": 422, "name": "黎巴嫩", "a2": "lb" },
    { "id": 426, "name": "莱索托", "a2": "ls" },
    { "id": 430, "name": "利比里亚", "a2": "lr" },
    { "id": 434, "name": "利比亚", "a2": "ly" },
    { "id": 438, "name": "列支敦士登", "a2": "li" },
    { "id": 440, "name": "立陶宛", "a2": "lt" },
    { "id": 442, "name": "卢森堡", "a2": "lu" },
    { "id": 446, "name": "澳门", "a2": "mo" },
    { "id": 450, "name": "马达加斯加", "a2": "mg" },
    { "id": 454, "name": "马拉维", "a2": "mw" },
    { "id": 458, "name": "马来西亚", "a2": "my" },
    { "id": 462, "name": "马尔代夫", "a2": "mv" },
    { "id": 466, "name": "马里", "a2": "ml" },
    { "id": 470, "name": "马耳他", "a2": "mt" },
    { "id": 584, "name": "马绍尔群岛", "a2": "mh" },
    { "id": 474, "name": "马提尼克", "a2": "mq" },
    { "id": 478, "name": "毛里塔尼亚", "a2": "mr" },
    { "id": 480, "name": "毛里求斯", "a2": "mu" },
    { "id": 175, "name": "马约特", "a2": "yt" },
    { "id": 484, "name": "墨西哥", "a2": "mx" },
    { "id": 583, "name": "密克罗尼西亚联邦", "a2": "fm" },
    { "id": 498, "name": "摩尔多瓦", "a2": "md" },
    { "id": 492, "name": "摩纳哥", "a2": "mc" },
    { "id": 496, "name": "蒙古", "a2": "mn" },
    { "id": 499, "name": "黑山", "a2": "me" },
    { "id": 500, "name": "蒙特塞拉特", "a2": "ms" },
    { "id": 504, "name": "摩洛哥", "a2": "ma" },
    { "id": 508, "name": "莫桑比克", "a2": "mz" },
    { "id": 104, "name": "缅甸", "a2": "mm" },
    { "id": 516, "name": "纳米比亚", "a2": "na" },
    { "id": 520, "name": "瑙鲁", "a2": "nr" },
    { "id": 524, "name": "尼泊尔", "a2": "np" },
    { "id": 528, "name": "荷兰", "a2": "nl" },
    { "id": 540, "name": "新喀里多尼亚", "a2": "nc" },
    { "id": 554, "name": "新西兰", "a2": "nz" },
    { "id": 558, "name": "尼加拉瓜", "a2": "ni" },
    { "id": 562, "name": "尼日尔", "a2": "ne" },
    { "id": 566, "name": "尼日利亚", "a2": "ng" },
    { "id": 570, "name": "纽埃", "a2": "nu" },
    { "id": 574, "name": "诺福克岛", "a2": "nf" },
    { "id": 807, "name": "北马其顿", "a2": "mk" },
    { "id": 580, "name": "北马里亚纳群岛", "a2": "mp" },
    { "id": 578, "name": "挪威", "a2": "no" },
    { "id": 512, "name": "阿曼", "a2": "om" },
    { "id": 586, "name": "巴基斯坦", "a2": "pk" },
    { "id": 585, "name": "帕劳", "a2": "pw" },
    { "id": 275, "name": "巴勒斯坦", "a2": "ps" },
    { "id": 591, "name": "巴拿马", "a2": "pa" },
    { "id": 598, "name": "巴布亚新几内亚", "a2": "pg" },
    { "id": 600, "name": "巴拉圭", "a2": "py" },
    { "id": 604, "name": "秘鲁", "a2": "pe" },
    { "id": 608, "name": "菲律宾", "a2": "ph" },
    { "id": 612, "name": "皮特凯恩群岛", "a2": "pn" },
    { "id": 616, "name": "波兰", "a2": "pl" },
    { "id": 620, "name": "葡萄牙", "a2": "pt" },
    { "id": 630, "name": "波多黎各", "a2": "pr" },
    { "id": 634, "name": "卡塔尔", "a2": "qa" },
    { "id": 638, "name": "留尼汪", "a2": "re" },
    { "id": 642, "name": "罗马尼亚", "a2": "ro" },
    { "id": 643, "name": "俄罗斯", "a2": "ru" },
    { "id": 646, "name": "卢旺达", "a2": "rw" },
    { "id": 652, "name": "圣巴泰勒米", "a2": "bl" },
    { "id": 654, "name": "圣赫勒拿、阿森松和特里斯坦-达库尼亚", "a2": "sh" },
    { "id": 659, "name": "圣基茨和尼维斯", "a2": "kn" },
    { "id": 662, "name": "圣卢西亚", "a2": "lc" },
    { "id": 663, "name": "法属圣马丁", "a2": "mf" },
    { "id": 666, "name": "圣皮埃尔和密克隆", "a2": "pm" },
    { "id": 670, "name": "圣文森特和格林纳丁斯", "a2": "vc" },
    { "id": 882, "name": "萨摩亚", "a2": "ws" },
    { "id": 674, "name": "圣马力诺", "a2": "sm" },
    { "id": 678, "name": "圣多美和普林西比", "a2": "st" },
    { "id": 682, "name": "沙特阿拉伯", "a2": "sa" },
    { "id": 686, "name": "塞内加尔", "a2": "sn" },
    { "id": 688, "name": "塞尔维亚", "a2": "rs" },
    { "id": 690, "name": "塞舌尔", "a2": "sc" },
    { "id": 694, "name": "塞拉利昂", "a2": "sl" },
    { "id": 702, "name": "新加坡", "a2": "sg" },
    { "id": 534, "name": "荷属圣马丁", "a2": "sx" },
    { "id": 703, "name": "斯洛伐克", "a2": "sk" },
    { "id": 705, "name": "斯洛文尼亚", "a2": "si" },
    { "id": 90, "name": "所罗门群岛", "a2": "sb" },
    { "id": 706, "name": "索马里", "a2": "so" },
    { "id": 710, "name": "南非", "a2": "za" },
    { "id": 239, "name": "南乔治亚和南桑威奇群岛", "a2": "gs" },
    { "id": 728, "name": "南苏丹", "a2": "ss" },
    { "id": 724, "name": "西班牙", "a2": "es" },
    { "id": 144, "name": "斯里兰卡", "a2": "lk" },
    { "id": 729, "name": "苏丹", "a2": "sd" },
    { "id": 740, "name": "苏里南", "a2": "sr" },
    { "id": 744, "name": "斯瓦尔巴和扬马延", "a2": "sj" },
    { "id": 752, "name": "瑞典", "a2": "se" },
    { "id": 756, "name": "瑞士", "a2": "ch" },
    { "id": 760, "name": "叙利亚", "a2": "sy" },
    { "id": 158, "name": "台湾", "a2": "tw" },
    { "id": 762, "name": "塔吉克斯坦", "a2": "tj" },
    { "id": 834, "name": "坦桑尼亚", "a2": "tz" },
    { "id": 764, "name": "泰国", "a2": "th" },
    { "id": 626, "name": "东帝汶", "a2": "tl" },
    { "id": 768, "name": "多哥", "a2": "tg" },
    { "id": 772, "name": "托克劳", "a2": "tk" },
    { "id": 776, "name": "汤加", "a2": "to" },
    { "id": 780, "name": "特立尼达和多巴哥", "a2": "tt" },
    { "id": 788, "name": "突尼斯", "a2": "tn" },
    { "id": 792, "name": "土耳其", "a2": "tr" },
    { "id": 795, "name": "土库曼斯坦", "a2": "tm" },
    { "id": 796, "name": "特克斯和凯科斯群岛", "a2": "tc" },
    { "id": 798, "name": "图瓦卢", "a2": "tv" },
    { "id": 800, "name": "乌干达", "a2": "ug" },
    { "id": 804, "name": "乌克兰", "a2": "ua" },
    { "id": 784, "name": "阿联酋", "a2": "ae" },
    { "id": 826, "name": "英国", "a2": "gb" },
    { "id": 840, "name": "美国", "a2": "us" },
    { "id": 581, "name": "美国本土外小岛屿", "a2": "um" },
    { "id": 858, "name": "乌拉圭", "a2": "uy" },
    { "id": 860, "name": "乌兹别克斯坦", "a2": "uz" },
    { "id": 548, "name": "瓦努阿图", "a2": "vu" },
    { "id": 862, "name": "委内瑞拉", "a2": "ve" },
    { "id": 704, "name": "越南", "a2": "vn" },
    { "id": 92, "name": "英属维尔京群岛", "a2": "vg" },
    { "id": 850, "name": "美属维尔京群岛", "a2": "vi" },
    { "id": 876, "name": "瓦利斯和富图纳", "a2": "wf" },
    { "id": 732, "name": "西撒哈拉", "a2": "eh" },
    { "id": 887, "name": "也门", "a2": "ye" },
    { "id": 894, "name": "赞比亚", "a2": "zm" },
    { "id": 716, "name": "津巴布韦", "a2": "zw" }
  ]
}